import React, { useState, useEffect } from 'react';

const TestimonialsSlider = () => {
  const testimonials = [
    {
      name: 'Sarah M.',
      location: 'Bloomington, IN',
      text: 'ObitAuthor made such a difficult time so much easier. The obituary was beautiful and professional, exactly what my mother would have wanted.',
      rating: 5
    },
    {
      name: 'Robert T.',
      location: 'Bend, OR',
      text: 'I was overwhelmed with everything I had to do, but ObitAuthor took care of the obituary perfectly. Thank you for making this process simple.',
      rating: 5
    },
    {
      name: 'Jennifer L.',
      location: 'Asheville, NC',
      text: 'The PDF was print-ready and looked absolutely perfect. Worth every penny to have one less thing to worry about during such a hard time.',
      rating: 5
    },
    {
      name: 'Michael D.',
      location: 'Savannah, GA',
      text: 'Fast, professional, and respectful. The obituary captured everything important about my father. Highly recommend.',
      rating: 5
    },
    {
      name: 'Patricia K.',
      location: 'Bozeman, MT',
      text: 'I used all 5 codes for different family members. Each obituary was beautifully written and formatted. This service is a lifesaver.',
      rating: 5
    },
    {
      name: 'David W.',
      location: 'Burlington, VT',
      text: 'The process was so easy and the result was exactly what we needed. Professional, dignified, and done in minutes.',
      rating: 5
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 8000); // Change testimonial every 8 seconds - gives people time to read

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="testimonials-slider-container mt-5">
      <div className="testimonials-slider-wrapper">
        <div 
          className="testimonials-slider"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card glass-card">
              <div className="testimonial-rating mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill"></i>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author mt-3">
                <strong>{testimonial.name}</strong>
                <span className="testimonial-location"> • {testimonial.location}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Dots indicator */}
      <div className="testimonials-dots mt-4">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`testimonial-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialsSlider;

